import dayjs from 'dayjs';
import tz from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import sameOrAfter from 'dayjs/plugin/isSameOrAfter';

dayjs.extend(utc);
dayjs.extend(tz);
dayjs.extend(sameOrAfter);

const isQuoteGuaranteed = ({ service_groups: serviceGroups }) => {
  if (!serviceGroups) return true;
  const guaranteedCheckMidnight = dayjs().hour(0).minute(0).second(0).millisecond(0).add(3, 'days');

  const allGroupsGuaranteed = serviceGroups.every((serviceGroup) => {
    const startMidnight = dayjs(serviceGroup.start_datetime)
      .tz(serviceGroup.start_timezone)
      .hour(0)
      .minute(0)
      .second(0)
      .millisecond(0);
    const guaranteedCheckMidnightLocalTz = guaranteedCheckMidnight.tz(serviceGroup.start_timezone);

    if (startMidnight.isAfter(guaranteedCheckMidnightLocalTz)) {
      return true;
    }
    return false;
  });

  return allGroupsGuaranteed;
};

export default isQuoteGuaranteed;
